import cake from '@assets/svg/redeem/Cake_icon.svg';
import clothing from '@assets/svg/redeem/Clothing_icon.svg';
import coffee from '@assets/svg/redeem/Coffee_icon.svg';
import food from '@assets/svg/redeem/Food_icon.svg';
import gadget from '@assets/svg/redeem/Gadget_icon.svg';
import giftbox from '@assets/svg/redeem/Gift_Box_icon.svg';
import giftcard from '@assets/svg/redeem/Gift_Card_icon.svg';
import soda from '@assets/svg/redeem/Soda_icon.svg';
import ticket from '@assets/svg/redeem/Ticket_icon.svg';
import trophy from '@assets/svg/redeem/Trophy_icon.svg';
import ball from '@assets/svg/redeem/Ball_icon.svg';
import books from '@assets/svg/redeem/Books_icon.svg';
import bottle_soda from '@assets/svg/redeem/Bottle_Soda_icon.svg';
import can_soda from '@assets/svg/redeem/Can_Soda_icon.svg';
import cap from '@assets/svg/redeem/Cap_icon.svg';
import ice_cream from '@assets/svg/redeem/ce_Cream_icon.svg';
import chocolate_bar from '@assets/svg/redeem/Chocolate_Bar_icon.svg';
import clipboard from '@assets/svg/redeem/Clipboard_icon.svg';
import diploma from '@assets/svg/redeem/Diploma_icon.svg';
import free_day from '@assets/svg/redeem/Free_Day_icon.svg';
import game_token from '@assets/svg/redeem/Game_Token_icon.svg';
import fruit_bowl from '@assets/svg/redeem/Fruit_Bowl_icon.svg';
import juice_box from '@assets/svg/redeem/Juice_Box_icon.svg';
import mention from '@assets/svg/redeem/Mention_icon.svg';
import music from '@assets/svg/redeem/Music_icon.svg';
import pencil_supply from '@assets/svg/redeem/Pencil_Supply_icon.svg';
import photo_moment from '@assets/svg/redeem/Photo_Moment_icon.svg';
import pizza_slice from '@assets/svg/redeem/Pizza_Slice_icon.svg';
import plant from '@assets/svg/redeem/Plant_icon.svg';
import plush from '@assets/svg/redeem/Plush_icon.svg';
import positive_vibes from '@assets/svg/redeem/Positive_Vibes_icon.svg';
import screen_time from '@assets/svg/redeem/Screen_Time_icon.svg';
import star_badge from '@assets/svg/redeem/Star_Badge_icon.svg';
import sticker from '@assets/svg/redeem/Stickers_icon.svg';
import water_bottle from '@assets/svg/redeem/Water_Bottle_icon.svg';
import art_set from '@assets/svg/redeem/Art_Set_icon.svg';

export default [
  { name: 'cake', icon: cake },
  { name: 'clothing', icon: clothing },
  { name: 'coffee', icon: coffee },
  { name: 'food', icon: food },
  { name: 'gadget', icon: gadget },
  { name: 'giftbox', icon: giftbox },
  { name: 'giftcard', icon: giftcard },
  { name: 'soda', icon: soda },
  { name: 'ticket', icon: ticket },
  { name: 'trophy', icon: trophy },
  { name: 'ball', icon: ball },
  { name: 'books', icon: books },
  { name: 'bottle_soda', icon: bottle_soda },
  { name: 'can_soda', icon: can_soda },
  { name: 'cap', icon: cap },
  { name: 'ice_cream', icon: ice_cream },
  { name: 'chocolate_bar', icon: chocolate_bar },
  { name: 'clipboard', icon: clipboard },
  { name: 'diploma', icon: diploma },
  { name: 'free_day', icon: free_day },
  { name: 'game_token', icon: game_token },
  { name: 'fruit_bowl', icon: fruit_bowl },
  { name: 'juice_box', icon: juice_box },
  { name: 'mention', icon: mention },
  { name: 'music', icon: music },
  { name: 'pencil_supply', icon: pencil_supply },
  { name: 'photo_moment', icon: photo_moment },
  { name: 'pizza_slice', icon: pizza_slice },
  { name: 'plant', icon: plant },
  { name: 'plush', icon: plush },
  { name: 'positive_vibes', icon: positive_vibes },
  { name: 'screen_time', icon: screen_time },
  { name: 'star_badge', icon: star_badge },
  { name: 'sticker', icon: sticker },
  { name: 'water_bottle', icon: water_bottle },
  { name: 'art_set', icon: art_set },
];
